import classNames from "classnames";
import Collapse from "rsuite/esm/Animation/Collapse";
import i18n from "../../i18n";
import {
  BreakpointDefinition,
  DashboardItemConfig,
} from "./ConfigurableDashboard";
import "./ConfigurableDashboardAddElementsBar.scss";

const SCALE_FACTOR = 1;
interface ConfigurableDashboardAddElementsBarProps {
  editMode: boolean;
  usedComponents: string[];
  selector: string;
  configs: DashboardItemConfig[];
  breakpoints: BreakpointDefinition;
  rowHeight: number;
  bright?: boolean;
}
const ConfigurableDashboardAddElementsBar = (
  props: ConfigurableDashboardAddElementsBarProps
) => {
  const notUsedConfigs = props.configs.filter((config) => {
    return !props.usedComponents.includes(config.id.toLowerCase());
  });

  return (
    <Collapse in={props.editMode}>
      <div>
        <div
          className={classNames(`configurable-dashbaord-add-elements-bar`, {
            bright: props.bright,
          })}
        >
          <div className={`title`}>
            {i18n.t(
              "ConfigurableDashboard.AddElementsBar.title",
              "Dashboard-Komponenten hinzufügen"
            )}
          </div>
          <div className={`elements`}>
            {notUsedConfigs.length === 0 && (
              <div className={`no-elements`}>
                {i18n.t(
                  "ConfigurableDashboard.AddElementsBar.noElements",
                  "Keine weiteren Komponenten verfügbar"
                )}
              </div>
            )}
            {notUsedConfigs.map((config) => (
              <div key={config.id} className="component-wrapper">
                <div
                  draggable={true}
                  unselectable="on"
                  id={config.id}
                  // this is a hack for firefox
                  // Firefox requires some kind of initialization
                  // which we can do by adding this attribute
                  // @see https://bugzilla.mozilla.org/show_bug.cgi?id=568313
                  onDragStart={(e) => {
                    e.dataTransfer.setData("text/plain", config.id);
                    // real ugly hack to send id to grid
                    e.dataTransfer.setData(config.id, config.id);

                    // Create custom drag preview to respect overflow constraints
                    const dragPreview = document.createElement("div");
                    dragPreview.style.position = "fixed";
                    dragPreview.style.top = "-1000px";
                    dragPreview.style.left = "-1000px";
                    dragPreview.style.width = "150px";
                    dragPreview.style.height = "150px";
                    dragPreview.style.overflow = "hidden";
                    dragPreview.style.background =
                      "var(--background-color-contrast)";
                    dragPreview.style.borderRadius =
                      "var(--border-radius-base)";
                    dragPreview.style.border =
                      "1px solid var(--border-color-secondary)";
                    dragPreview.style.pointerEvents = "none";
                    dragPreview.style.zIndex = "9999";
                    dragPreview.style.display = "flex";
                    dragPreview.style.alignItems = "center";
                    dragPreview.style.justifyContent = "center";
                    dragPreview.style.fontSize = "12px";
                    dragPreview.style.color = "var(--text-color-primary)";
                    dragPreview.style.textAlign = "center";
                    dragPreview.style.padding = "10px";

                    // Show the component title instead of complex content
                    dragPreview.textContent = config.title;

                    document.body.appendChild(dragPreview);

                    // Set the custom drag image
                    e.dataTransfer.setDragImage(dragPreview, 75, 75);

                    // Clean up the preview element after drag starts
                    setTimeout(() => {
                      if (document.body.contains(dragPreview)) {
                        document.body.removeChild(dragPreview);
                      }
                    }, 0);
                  }}
                  className={`__card available-component`}
                  data-grid={{
                    minW: config.layout[props.selector]?.minW || 1,
                    minH: config.layout[props.selector]?.minH || 1,
                    maxW: config.layout[props.selector]?.maxW,
                    maxH: config.layout[props.selector]?.maxH,
                  }}
                  style={{
                    // transform: "scale(0.65)",
                    // margin: "-20px",
                    // width:
                    //   ((config.layout[props.selector]?.minW || 1) /
                    //     props.breakpoints[props.selector].columns) *
                    //     100 *
                    //     SCALE_FACTOR +
                    //   "%",
                    height: 150,
                    width: 150,
                    overflow: "hidden",
                  }}
                  title={config.description || config.title}
                >
                  <div
                    className={`__card`}
                    style={{
                      width: 500,
                      height: 500,
                      transform: "scale(0.3)",
                      transformOrigin: "top left",
                      pointerEvents: "none",
                      overflow: "hidden",
                    }}
                  >
                    {config.render("xs")}
                  </div>
                </div>
                <div className="component-title">{config.title}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Collapse>
  );
};

export default ConfigurableDashboardAddElementsBar;
